import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { isNil, noop } from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';

import {
  getPricingListFiltered,
  GetPricingListFilteredParams,
  PricingResponse,
} from 'services/pricing';

export type PricingListFilteredSelectProps = {
  params: GetPricingListFilteredParams;
  value?: any;
  onChange?: (pricing?: PricingResponse) => void;
  onClear?: (() => void)
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
  defaultValue?: any;
};

const PricingListFilteredSelect = ({
  params,
  value,
  onChange = noop,
  allowClear,
  defaultValue,
  onClear,
  ...otherProps
}: PricingListFilteredSelectProps) => {
  const { data: pricings, isLoading } = useQuery(
    ['getPricingListFiltered', params],
    () => getPricingListFiltered(params).then((res) => res.list || [])
  );

  const handleChange: SelectProps<number>['onChange'] = (value) => {

    onChange(pricings?.find((pricing) => pricing.priid === value));
  };
  return (
    <Select
      value={
        !isNil(value)
          ? typeof value !== 'object'
            ? Number(value)
            : Number(value?.priid)
          : ('' as any)
      }
      onChange={handleChange}
      {...otherProps}
      loading={isLoading}
      defaultValue={defaultValue?.priid ?? defaultValue}
      allowClear={allowClear}
      onClear={onClear}
    >
      {pricings?.map((pricing,index) => (
        <Select.Option value={pricing.priid} key={pricing.priid + index}>
          {pricing.prilabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default PricingListFilteredSelect;
